import { Component, Input, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';
import { HeaderService } from 'src/app/core/services/header.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit {
  list: {
    label: string;
    link: string;
  }[] = [];

  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  constructor(private headerService: HeaderService) { }

  ngOnInit(): void {
    this.headerService.breadcrumb$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.list = res;
      });
  }
}
